import { Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { PasswordRecoverComponent } from './password-recover/password-recover.component';

export const AUTH_ROUTES: Routes = [
  {path: 'login', component: LoginComponent },
  {path: 'password-recover', component: PasswordRecoverComponent },


];
